import styled from "styled-components";

import Page from "../pageView/Page";
import { ModalProvider } from "../modal/useModalDialog";
import ListViewComp from "../listView/ListView";
import BackButton from "../generic/BackButton";
import useTranslation from "../../hooks/useTranslation";

const ComponentWrapper = styled.div`
    min-height: 400px;
    max-height: 80vh;
    overflow: scroll;
    padding: 0.25rem;
`


const PersonalInfoForm = () => (
    <form>
        <label>
            Name:
            <input type="text" name="name" />
        </label>
        <label>
            Email:
            <input type="email" name="email" />
        </label>
    </form>
);

const PreferencesForm = () => (<p>List of all Invoices</p>)
const ReviewForm = () => (<p>Review</p>)

const ListView = ({ listType, options, description, selectAction, stepData, onStepData, onNext }) => {
    const { t } = useTranslation()

    const handleSelectConfirm = (selectedItems) => {
        onStepData && onStepData({ ...stepData, selectedItems })
        onNext && onNext()
    }

    return (
        <ComponentWrapper>
            <ModalProvider>
                <h3>
                    <BackButton config={{}} />
                    {t(description)}
                </h3>
                <ListViewComp
                    type={listType}
                    selectAction={selectAction}
                    onSelectConfirm={handleSelectConfirm}
                    embedded
                />
            </ModalProvider>
        </ComponentWrapper>
    )
}


const PageView = ({ pageType, options, stepData, onBack }) => {
    return (
        <Page
            type={pageType}
            options={{ ...options, stepData, backAction: onBack }}
        />
    )
}




// Mapping of component names to actual components
const componentMap = {
    PersonalInfoForm,
    PreferencesForm,
    ReviewForm,
    ListView,
    PageView
};


const StepComponent = ({ component, stepData, onStepData, onNext, onBack }) => {
    const Component2Diplay = componentMap[component.type]

    return (
            <Component2Diplay {...component} stepData={stepData} onStepData={onStepData} onNext={onNext} onBack={onBack} />
    )

}

export default StepComponent
